// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: robot_interfaces/msg/RobotState.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { BatteryState } from "../../sensor_msgs/msg/BatteryState";
import { Header } from "../../std_msgs/msg/Header";
import { OperationMode } from "./OperationMode";

export const protobufPackage = "robot_interfaces.msg.pb";

export interface RobotState {
  header:
    | Header
    | undefined;
  /** Battery */
  battery:
    | BatteryState
    | undefined;
  /** Operation */
  operation_mode:
    | OperationMode
    | undefined;
  /** Connected payload / sensor names attached to the robot. */
  payload_names: string[];
  status_message: string;
}

function createBaseRobotState(): RobotState {
  return { header: undefined, battery: undefined, operation_mode: undefined, payload_names: [], status_message: "" };
}

export const RobotState: MessageFns<RobotState> = {
  encode(message: RobotState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(1939194666).fork()).join();
    }
    if (message.battery !== undefined) {
      BatteryState.encode(message.battery, writer.uint32(2172158058).fork()).join();
    }
    if (message.operation_mode !== undefined) {
      OperationMode.encode(message.operation_mode, writer.uint32(3318844802).fork()).join();
    }
    for (const v of message.payload_names) {
      writer.uint32(188808866).string(v!);
    }
    if (message.status_message !== "") {
      writer.uint32(4083874690).string(message.status_message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 242399333: {
          if (tag !== 1939194666) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 271519757: {
          if (tag !== 2172158058) {
            break;
          }

          message.battery = BatteryState.decode(reader, reader.uint32());
          continue;
        }
        case 414855600: {
          if (tag !== 3318844802) {
            break;
          }

          message.operation_mode = OperationMode.decode(reader, reader.uint32());
          continue;
        }
        case 23601108: {
          if (tag !== 188808866) {
            break;
          }

          message.payload_names.push(reader.string());
          continue;
        }
        case 510484336: {
          if (tag !== 4083874690) {
            break;
          }

          message.status_message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotState {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      battery: isSet(object.battery) ? BatteryState.fromJSON(object.battery) : undefined,
      operation_mode: isSet(object.operationMode)
        ? OperationMode.fromJSON(object.operationMode)
        : isSet(object.operation_mode)
        ? OperationMode.fromJSON(object.operation_mode)
        : undefined,
      payload_names: globalThis.Array.isArray(object?.payloadNames)
        ? object.payloadNames.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.payload_names)
        ? object.payload_names.map((e: any) => globalThis.String(e))
        : [],
      status_message: isSet(object.statusMessage)
        ? globalThis.String(object.statusMessage)
        : isSet(object.status_message)
        ? globalThis.String(object.status_message)
        : "",
    };
  },

  toJSON(message: RobotState): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.battery !== undefined) {
      obj.battery = BatteryState.toJSON(message.battery);
    }
    if (message.operation_mode !== undefined) {
      obj.operationMode = OperationMode.toJSON(message.operation_mode);
    }
    if (message.payload_names?.length) {
      obj.payloadNames = message.payload_names;
    }
    if (message.status_message !== "") {
      obj.statusMessage = message.status_message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotState>, I>>(base?: I): RobotState {
    return RobotState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotState>, I>>(object: I): RobotState {
    const message = createBaseRobotState();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.battery = (object.battery !== undefined && object.battery !== null)
      ? BatteryState.fromPartial(object.battery)
      : undefined;
    message.operation_mode = (object.operation_mode !== undefined && object.operation_mode !== null)
      ? OperationMode.fromPartial(object.operation_mode)
      : undefined;
    message.payload_names = object.payload_names?.map((e) => e) || [];
    message.status_message = object.status_message ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
